export enum SysRegions {
  TCTS4 = 'TCTS4',
  TCTS5 = 'TCTS5',
  TCTSG = 'TCTSG',
  TCTSL = 'TCTSL',
  TCTSN = 'TCTSN',
}
